import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { IDull, IDullInitialState } from "./dullModel";
import {
  createDull,
  deleteDull,
  deleteDullOrderItems,
  findAllDull,
  getDullById,
  updateDull,
} from "./services/dull.services";

const initialState: IDullInitialState = {
  loading: false,
  error: "",
  DullID: null,
  DullOrderItemIndex: null,
  DullOrderSelectionDialog: false,
  DullList: [],
  DullDetail: {
    issue_date: new Date(),
    approx_delivery_date: "",
    karigar_id: null,
    dull_issue_order: [],
  },
  FilterDull: {
    karigar_name: "",
    karigar_nick_name: "",
    issue_date: "",
    approx_delivery_date: "",
  },
};

const dullSlice = createSlice({
  name: "dull",
  initialState,
  reducers: {
    setDullID: (state, action) => {
      state.DullID = action.payload;
    },
    clearDullDetail: (state) => {
      state.DullDetail = initialState.DullDetail;
    },
    setDullOrderItemIndex: (state, action) => {
      state.DullOrderItemIndex = action.payload;
    },
    setFilterDull: (state, action) => {
      state.FilterDull = action.payload;
    },
    clearFilterDull: (state) => {
      state.FilterDull = initialState.FilterDull;
    },
    openDullOrderSelectionDialog: (state) => {
      state.DullOrderSelectionDialog = true;
    },
    closeDullOrderSelectionDialog: (state) => {
      state.DullOrderSelectionDialog = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(findAllDull.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      findAllDull.fulfilled,
      (state, action: PayloadAction<IDull[]>) => {
        state.loading = false;
        state.DullList = action.payload || [];
      }
    );
    builder.addCase(findAllDull.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.DullList = [];
    });

    builder.addCase(createDull.pending, (state) => {
      state.loading = false;
      state.error = "";
    });
    builder.addCase(createDull.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(createDull.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(updateDull.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(updateDull.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(updateDull.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(deleteDull.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteDull.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteDull.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(getDullById.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getDullById.fulfilled, (state, action: any) => {
      state.loading = false;
      state.DullDetail = action.payload;
    });
    builder.addCase(getDullById.rejected, (state, action) => {
      state.loading = false;
      state.DullDetail = initialState.DullDetail;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(deleteDullOrderItems.pending, (state) => {
      state.loading = false;
      state.error = "";
    });
    builder.addCase(deleteDullOrderItems.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteDullOrderItems.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const {
  clearDullDetail,
  setDullID,
  setDullOrderItemIndex,
  clearFilterDull,
  setFilterDull,
  closeDullOrderSelectionDialog,
  openDullOrderSelectionDialog,
} = dullSlice.actions;
export default dullSlice.reducer;
